import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseTextarea = {
  backgroundColor: css`var(--cse-textarea-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-textarea-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-textarea-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-textarea-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-textarea-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-textarea-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-textarea-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-textarea-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-textarea-color-disabled, ${csFormControl.colorDisabled})`,
  fontSize: css`var(--cse-textarea-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-textarea-font-family, ${csFormControl.fontFamily})`,
  paddingInline: css`var(--cse-textarea-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-textarea-padding-y, ${csFormControl.paddingInline})`,
  outlineFocus: css`var(--cse-textarea-outline-focus, ${csFormControl.outlineFocus})`,
  placeholderColor: css`var(--cse-textarea-placeholder-color, ${csFormControl.placeholderColor})`,
}

export const style: CSSResult = css`
  :host {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing02};
  }

  textarea {
    background: ${cseTextarea.backgroundColor};
    border-width: ${cseTextarea.borderWidth};
    border-style: solid;
    border-color: ${cseTextarea.borderColor};
    border-radius: ${cseTextarea.borderRadius};
    color: ${cseTextarea.color};
    font-size: ${cseTextarea.fontSize};
    font-family: ${cseTextarea.fontFamily};
    margin: 0;
    padding-block: ${cseTextarea.paddingBlock};
    padding-inline: ${cseTextarea.paddingInline};
    resize: vertical;
    transition-duration: ${csTransition.duration};
    transition-property: border-color, color;
    transition-timing-function: ${csTransition.timingFunction};
    width: 100%;
  }

  textarea[disabled] {
    background-color: ${cseTextarea.backgroundColorDisabled};
    color: ${cseTextarea.colorDisabled};
    resize: none;
  }

  textarea::placeholder {
    color: ${cseTextarea.placeholderColor};
    opacity: 1;
  }

  textarea:focus-visible {
    outline: ${cseTextarea.outlineFocus};
  }

  .resize-none {
    resize: none;
  }

  textarea.valid-error {
    border-color: ${cseTextarea.borderColorError};
  }

  textarea.valid-success {
    border-color: ${cseTextarea.borderColorSuccess};
  }
`
